// SectionControls.jsx
import React from 'react';
import { Box, Typography, FormControlLabel, Switch, Stack } from '@mui/material';

const SectionControls = ({ sectionId, sections, setSections }) => {
  const sectionSettings = sections[sectionId]?.settings || {};

  const updateSetting = (key, value) => {
    setSections(prev => ({
      ...prev,
      [sectionId]: {
        ...prev[sectionId],
        settings: {
          ...(prev[sectionId]?.settings || {}),
          [key]: value,
        },
      },
    }));
  };

  return (
    <Box sx={{ mb: 3, p: 2, bgcolor: '#f0f8ff', borderRadius: 1 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>Section Controls</Typography>
      <Stack spacing={1}>
        <FormControlLabel
          control={
            <Switch
              checked={sectionSettings.showAddButton !== false}
              onChange={e => updateSetting('showAddButton', e.target.checked)}
            />
          }
          label="Show + Add Item Button"
        />
        <FormControlLabel
          control={
            <Switch
              checked={sectionSettings.showDeleteButton === true}
              onChange={e => updateSetting('showDeleteButton', e.target.checked)}
            />
          }
          label="Show Delete Button on Items"
        />
      </Stack>
    </Box>
  );
};

export default SectionControls;